<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.teacherSalaryList.push"
    :is-show-store-select="true"
    :is-show-search-input="true"
  >
    <v-column-time/>
    <v-column-avatar/>
    <el-table-column label="所属门店" width="130" prop="store_name"/>
    <el-table-column label="底薪（元）" width="130">
      <template v-slot="{ row }">
        <span>{{ row.base_pay | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="单节大课费用（元）" width="130">
      <template v-slot="{ row }">
        <span>{{ row.class_pay | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="单节私教课费用（元）" width="130">
      <template v-slot="{ row }">
        <span>{{ row.private_class_pay | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="旷课扣费（元）" width="130">
      <template v-slot="{ row }">
        <span>{{ row.leave_class_pay | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="社保费用" width="130">
      <template v-slot="{ row }">
        <span>{{ row.social_insurance | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="个人社保费用" width="130">
      <template v-slot="{ row }">
        <span>{{ row.personal_insurance | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column width="310px">
      <template v-slot="{ row }">
        <v-list-button name="修改薪资" size="large" :to="RouteConfig.teacherSalaryEdit.to(row.id)"/>
        <v-list-button
          :name="`移出${isAdministrator ? '该店' : '本店'}`"
          size="large"
          @click="handleDelete(row.id)"
          :is-loading="isDeleting[row.id]"
          :message="`此操作将删除${row.store_name}店的薪资设置，确认要继续吗？`"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`teacher-salary-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>老师</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>底薪（元）</span>
              <span>{{ v.base_pay | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>单节大课费用（元）</span>
              <span>{{ v.class_pay | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>单节私教课费用（元）</span>
              <span>{{ v.private_class_pay | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>旷课扣费（元）</span>
              <span>{{ v.leave_class_pay | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>社保费用</span>
              <span>{{ v.social_insurance | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>个人社保费用</span>
              <span>{{ v.personal_insurance | toYuan }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button name="修改薪资" size="large" :to="RouteConfig.teacherSalaryEdit.to(v.id)"/>
              <v-list-button
                :name="`移出${isAdministrator ? '该店' : '本店'}`"
                size="large"
                @click="handleDelete(v.id)"
                :is-loading="isDeleting[v.id]"
                :message="`此操作将删除${v.store_name}店的薪资设置，确认要继续吗？`"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, destroy } from '@/api/store-teacher';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.teacherSalaryList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      store_id: '',
      limit: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    isLoading: false,
    isDeleting: {},
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
      'defaultStoreId',
    ]),
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete(id) {
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id);
      this.$set(this.isDeleting, id, false);
      if (isError) return;

      this.load();
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>
